import { Component, Input } from '@angular/core';

@Component({
  selector: 'lib-ds-info-banner',
  templateUrl: './info-banner.component.html',
  styleUrls: ['./info-banner.component.scss']
})
export class DsInfoBannerComponent {
  @Input() text?: string;
  @Input() linkText?: string;
  @Input() linkUrl?: string;
  @Input() iconSrc?: string;
}

